//

import React, { useState, useEffect, useCallback, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  createUser,
  fetchCity,
  fetchCountry,
  fetchProductPrices,
  fetchProducts,
  fetchState,
  fetchSubUsers,
} from "../services/admin-services";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";

interface UserList {
  _id: string;
  email: string;
  status?: number;
  fullName?: string;
  phoneNumber?: string;
  companyName?: string;
  countryName?: string;
  creationDetails?: CreationDetails;
  isSubscribed?: boolean;
  stripe_product?: string;
}

interface CreationDetails {
  email?: string;
  fullName?: string;
  pgCustomerId?: string;
  status?: number;
  _id?: string;
  paymentDetails?: PaymentDetails;
}
interface PaymentDetails {
  productId?: string;
  provider?: string;
}

interface Price {
  currency: string; // Required
  productId: string; // Required
  unitAmount?: string;
  recurring?: {
    interval: string;
    interval_count: number;
  };
  priceId: string; // Required
}

// import { Pagination } from '@/components/ui/pagination';
// import { Musers } from "./mockData";
import Input from "@mui/material/Input";
// import { Label } from "@radix-ui/react-select";
// import { Musers } from './mockData';
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "@/contexts/LoadingContext";
// import { PhoneNumber } from "react-phone-number-input";
import toastService from "@/services/toastService";
// import { CreationDetails } from '@/features/user-profile/organization-user/organization-users';
// import { Tooltip, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
interface PaginationData {
  page: number;
  limit: number;
  nextPage: number;
}

const SubUserList: React.FC = () => {
  const [users, setUsers] = useState<UserList[]>([]);
  const { setLoading } = useLoading();
  const [error, setError] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pagination, setPagination] = useState<PaginationData>({
    page: 1,
    limit: 10,
    nextPage: -1,
  });


  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  // const [stripeProduct, setStripeProduct] = useState("");
  const [stripePriceId, setStripePriceId] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  // const [city, setCity] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [productId, setProductId] = useState("");
  const [products, setProducts] = useState<{ id: string; name: string }[]>([]);
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);

  const [hasLoaded, setHasLoaded] = useState(false);
  const [prices, setPrices] = useState<Price[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [city, setCity] = useState("");
  // const [hasLoadedCities, setHasLoadedCities] = useState(false);


  const pathname = window.location.pathname; // Get the current URL path

  // Conditionally set the title based on the URL path
  const title =
    pathname === "/admin/dashboard/subscribed-users"
      ? "Subscribed Users"
      : pathname === "/admin/dashboard/all-users" || pathname === "/admin/dashboard"
        ? "All Users"
        : "";
  const fetchProduct = async () => {
    if (!hasLoaded) {
      try {
        const response = await fetchProducts();
        // const data = await res.json()
        console.log(response?.data?.products, "line 101");

        setProducts(response?.data?.products);
        setHasLoaded(true);
      } catch (err) {
        console.error("Failed to load products:", err);
      }
    }
  };
  const fetchCountryName = async () => {
    // if (!hasLoaded) {
    try {
      const response = await fetchCountry();
      // const data = await res.json()
      console.log(response?.data?.countries, "line 101");

      setCountries(response?.data?.countries);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };
  const fetchStateName = async (country: string) => {
    try {
      console.log("line 151");
      const response = await fetchState(country);
      // const data = await res.json()
      console.log(response?.data, "line 101");
      setStates(response?.data?.states);

      // setProducts(response?.data?.products);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
  };
  const fetchCityName = async (country: string, state: string) => {
    // if (!hasLoaded) {
    try {
      const response = await fetchCity(country, state);
      // const data = await res.json()
      console.log(response?.data, "line 101");

      // setProducts(response?.data?.products);
      setCities(response?.data?.cities);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };
  const location = useLocation();
  const navigate = useNavigate();

  const isSubscribedRoute = location.pathname.includes("/subscribed-users");
  const fetchUserList = useCallback(
    async (query = ""): Promise<UserList[] | []> => {
      setLoading(true);
      try {
        const params = {
          page: pagination.page,
          limit: pagination.limit,
          q: query,
          ...(isSubscribedRoute && { subscribed: true }),
        };
        if (pagination.page !== 1 && isSubscribedRoute !== prevRouteRef.current) {
          return [];
        }
        const response = await fetchSubUsers(params);
        const userList = response?.data?.users;
        setUsers(userList);
        setPagination((prev) => ({
          ...prev,
          nextPage: response?.data?.nextPage || -1,
        }));
        return userList;
      } catch (err) {
        console.error("Error fetching users:", err);
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
        return [];
      } finally {
        setLoading(false);
      }
    },
    [pagination.page, pagination.limit, isSubscribedRoute, setLoading]
  );
  useEffect(() => {
    setPagination(prev => ({
      ...prev,
      page: 1,  // Always reset to page 1 when route changes
      limit: 10,
    }));
  }, [isSubscribedRoute]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const userList = await fetchUserList();
        if (isMounted) {
          setUsers(userList);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [fetchUserList]);

  const prevRouteRef = useRef(isSubscribedRoute);
  useEffect(() => {
    prevRouteRef.current = isSubscribedRoute;
  }, [isSubscribedRoute]);

  // useEffect(() => {
  //   fetchUserList().then(setUsers);
  // }, [fetchUserList]);



  useEffect(() => {
    if (!isDialogOpen) handleDialogClose();
  }, [isDialogOpen]);

  const handleDialogClose = () => {
    setStripePriceId("")
    setFullName("")
    setEmail("")
    setStripePriceId("")
    setCompany("")
    setPhone("")
    setProductId("")
    setCity("")
    setCountry("")
    setState("")
    setIsDialogOpen(false)
    // fetchUserList()
  };

  if (error) {
    return (
      <div className="p-4 bg-red-100 text-red-700 rounded-md">
        Error: {error}
      </div>
    );
  }

  const handleStripePriceId = async (open: boolean) => {
    if (productId) {
      try {
        console.log(open,"line 225")
        const response = await fetchProductPrices(productId);
        setPrices(response?.data?.prices);
        setHasLoaded(true);
      } catch (err) {
        console.error("Failed to load stripe prices:", err);
      }
    }
  };
  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleLimitChange = (newLimit: number) => {
    setPagination((prev) => ({ ...prev, limit: newLimit, page: 1 }));
  };
  const handleCreateUser = async () => {
    // if (!contactName || !contactEmail || !selectedLicense) {
    //   alert("Please fill all required fields");
    //   return;
    // }
    // console.log(selectedLicense, "----selectedLicense");

    // const userData = {
    //   name: contactName,
    //   email: contactEmail,
    //   product_id: productId,
    //   group_ids: Object.values(selectedGroups)
    //     .map((v) => (v ? +v : undefined))
    //     .filter((v) => !!v) as number[],
    //   password: password,
    // };

    // createSubUser(userData);
    console.log(
      fullName,
      email,
      phone,
      productId,
      stripePriceId,
      country,
      "line 136"
    );
    // const userData = {
    //   fullName: fullName,
    //   email: email,
    //   stripePriceId: stripePriceId,
    //   countryName:country,
    //   companyName: company,
    //   city:city,
    //   state:state
    // }
    const rawUserData = {
      fullName: fullName,
      email: email,
      stripePriceId: stripePriceId,
      countryName: country,
      companyName: company,
      city: city,
      state: state,
      phoneNumber: phone,
    };

    // Filter out empty (falsy) values
    const userData = Object.fromEntries(
      Object.entries(rawUserData).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
    );
    // console.log(userData,"line 302")
    const response = await createUser(userData)
    // console.log(response, "line 271")
    if (response.statusCode === 201) {
      toastService.success("User created successfully and payment link sent")
    }
    handleDialogClose();
    fetchUserList()

  }; // Close dialog after submission

  const handleRowClick = (userId: string) => {
    navigate(`/admin/dashboard/users/${userId}`);
  };

  return (
    <div className="h-full w-full mx-auto  pl-12 2xl:pl-0  mt-0">
      {users.length === 0 ? (
        <div className="flex flex-col items-center justify-center text-center">
          {/* <img src={noOrders} alt="No Users" className="w-48 h-48 mb-4" /> */}
          {/* <p className="text-gray-500">No Users Exist</p> */}
          {/* <Button className="Create-New-User bg-charcoal mt-6 rounded-md px-[41px] py-[8px]">
            Add New User
          </Button> */}
        </div>
      ) : (
        <>
          <div className="w-full mt-6 mb-5">
            <div className="flex justify-between items-center w-[95%] mx-auto  ">
              <h2 className="font-[Outfit] text-[24px] font-medium leading-[1.2] text-black whitespace-nowrap">
                {title}
              </h2>

              <div className="ml-10">
                <Button
                  size="sm"
                  className="Create-New-User mb-3  bg-charcoal text-left  rounded-md px-[20px] "
                  onClick={() => setIsDialogOpen(true)}
                >
                  Add New User
                </Button>
              </div>
            </div>
            <div className=" border-t w-full mx-auto border-[#e4e4e4]" />
          </div>

          {users.length === 0 ? (
            <div className="flex justify-center items-center h-64">
              <p className="text-gray-500 text-lg">No Users Exist</p>
            </div>
          ) : (
            <Table className="mt-2 ml-10  rounded-md  w-[95%] mx-auto mb-2 ">
              <TableHeader className="bg-[#f9f9f9] rounded-md ">
                <TableRow>
                  <TableHead className="p-3 text-black text-center rounded-md">
                    Name
                  </TableHead>
                  <TableHead className="p-3 text-black text-center rounded-md">
                    Email
                  </TableHead>
                  <TableHead className="p-3 text-black text-center rounded-md">
                    Phone
                  </TableHead>
                  <TableHead className="p-3 text-black text-center rounded-md">
                    Company
                  </TableHead>

                  <TableHead className="p-3 text-black text-center rounded-md">
                    Country
                  </TableHead>
                  <TableHead className="p-3 text-black text-center rounded-md">
                    Subscription Status
                  </TableHead>
                  {/* <TableHead className="p-3 text-black text-center rounded-md">
                    Subscription Plan
                  </TableHead> */}
                </TableRow>
              </TableHeader>

              <TableBody className="rounded-md border-l text-[#181818] font-[outfit] text-[14px] border-r ">
                {users.map((user) => (
                  <TableRow
                    key={user._id}
                    className="hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleRowClick(user._id)}
                  >
                    <TableCell className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]">
                      {user.fullName ? user.fullName : "--"}
                    </TableCell>
                    <TableCell

                      className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]"
                    >
                      {user.email ? user.email : "--"}
                    </TableCell>

                    <TableCell className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]">
                      {user.phoneNumber ? user.phoneNumber : "--"}
                    </TableCell>

                    <TableCell className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]">
                      {user.companyName ? user.companyName : "--"}
                    </TableCell>
                    <TableCell className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]">
                      {user.countryName ? user.countryName : "--"}
                    </TableCell>
                    <TableCell className="p-3 text-center rounded-md text-[16px] leading-[24px] tracking-[0.3px]">
                      {user?.isSubscribed !== undefined ? (
                        <span className={user.isSubscribed ? "text-green-600 font-medium" : "text-red-600 font-medium"}>
                          {user.isSubscribed ? "Active" : "Inactive"}
                        </span>
                      ) : (
                        "-"
                      )}
                       </TableCell>
                      {/* <TableCell className="p-3 text-center rounded-md text-[#181818] text-[16px] leading-[24px] tracking-[0.3px]">
                        {user.stripe_product ? user.stripe_product : "-"}
                      </TableCell> */}
                   

                  </TableRow>
                ))}
              </TableBody>
              <TableRow className="rounded-md border">
                <TableCell colSpan={5}>
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="text-gray-700 font-medium mr-2">
                        Showing
                      </span>

                      <select
                        value={pagination.limit}
                        onChange={(e) => handleLimitChange(Number(e.target.value))}
                        className="p-1 border rounded-md"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div className="flex items-center space-x-4">
                      <Button
                        variant="outline"
                        disabled={pagination.page === 1}
                        onClick={() => handlePageChange(pagination.page - 1)}
                      >
                        <FaChevronLeft />
                      </Button>
                      <span className="text-gray-700 font-medium">
                        Page {pagination.page}
                      </span>
                      <Button
                        variant="outline"
                        disabled={pagination.nextPage === -1}
                        onClick={() => handlePageChange(pagination.page + 1)}
                      >
                        <FaChevronRight />
                      </Button>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </Table>
          )}
        </>
      )}
      <Dialog modal={false} open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        {isDialogOpen && (
          <section className="fixed inset-0 bg-black/70 z-[50]">
            <DialogContent className="max-w-2xl p-6">
              <DialogHeader>
                <DialogTitle className="text-xl font-semibold text-gray-700">
                  Add New User
                </DialogTitle>
              </DialogHeader>

              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Full Name
                  </label>
                  <Input
                    placeholder="Contact Name"
                    className="p-2 text-sm border rounded-md"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <Input
                    placeholder="Enter Email"
                    className="p-2 text-sm border rounded-md"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>


                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Phone
                  </label>
                  <Input
                    placeholder="Enter Phone"
                    className="p-2 text-sm border rounded-md"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Company
                  </label>
                  <Input
                    placeholder="Enter Company"
                    className="p-2 text-sm border rounded-md"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Stripe Product <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={productId}
                    onValueChange={setProductId}
                    onOpenChange={fetchProduct}
                  >
                    <SelectTrigger className="p-2 text-sm border rounded-md">
                      <SelectValue placeholder="Select Stripe Product" />
                    </SelectTrigger>
                    <SelectContent>
                      {products.length > 0 ? (
                        products.map((product) => (
                          <SelectItem key={product.id} value={product.id}>
                            {product.name}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="__loading" disabled>
                          Loading...
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Stripe Price ID <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={stripePriceId}
                    onValueChange={setStripePriceId}
                    onOpenChange={handleStripePriceId}
                    disabled={!productId}
                  >
                    <SelectTrigger className="p-2 text-sm border rounded-md bg-white">
                      <SelectValue
                        placeholder={
                          productId ? "Select Price" : "Select Product First"
                        }
                      />
                    </SelectTrigger>
                    <SelectContent>
                      {prices.length > 0 ? (
                        prices.map((price, index) => (
                          <SelectItem
                            key={price.priceId ?? index}
                            value={price.priceId ?? ""}
                          >
                            {`${price.currency?.toUpperCase() ?? "N/A"} ${price.unitAmount ?? ""} ${price.recurring?.interval
                              ? `(${price.recurring.interval})`
                              : ""
                              }`}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="__loading" disabled>
                          {hasLoaded ? "No prices found" : "Loading..."}
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-gray-600">
                    Country
                  </label>
                  <Select
                    value={country}
                    onValueChange={setCountry}
                    onOpenChange={fetchCountryName}
                  >
                    <SelectTrigger className="p-2 text-sm border rounded-md bg-white">
                      <SelectValue placeholder="Select Country" />
                    </SelectTrigger>
                    <SelectContent>
                      {countries.length > 0 ? (
                        countries.map((c) => (
                          <SelectItem key={c} value={c}>
                            {c}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="__loading" disabled>
                          {hasLoaded ? "No countries found" : "Loading..."}
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                </div>
                {country &&
                  <div className="flex flex-col">
                    <label className="mb-1 text-sm font-medium text-gray-600">
                      State
                    </label>
                    <Select
                      value={state}
                      onValueChange={setState}
                      onOpenChange={(open) => {
                        if (open && country) {
                          console.log("Calling fetchStateName with:", country);
                          fetchStateName(country);
                        } else {
                          console.log(
                            "Dropdown closed or country not selected yet."
                          );
                        }
                      }}
                    >
                      <SelectTrigger className="p-2 text-sm border rounded-md bg-white">
                        <SelectValue placeholder="Select State" />
                      </SelectTrigger>
                      <SelectContent>
                        {states.length > 0 ? (
                          states.map((s) => (
                            <SelectItem key={s} value={s}>
                              {s}
                            </SelectItem>
                          ))
                        ) : (
                          <SelectItem value="__loading" disabled>
                            {hasLoaded ? "No states found" : "Loading..."}
                          </SelectItem>
                        )}
                      </SelectContent>
                    </Select>
                  </div>
                }
                {state && (
                  <div className="flex flex-col">
                    <label className="mb-1 text-sm font-medium text-gray-600">
                      City
                    </label>
                    <Select
                      value={city}
                      onValueChange={setCity}
                      onOpenChange={(open) => {
                        if (open && state) {
                          fetchCityName(country, state)
                        }
                      }}
                    >
                      <SelectTrigger className="p-2 text-sm border rounded-md bg-white">
                        <SelectValue placeholder="Select City" />
                      </SelectTrigger>
                      <SelectContent>
                        {cities.map((c) => (
                          <SelectItem key={c} value={c}>
                            {c}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                )}

              </div>

              <div className="flex justify-end space-x-4 mt-6">
                <Button
                  variant="outline"
                  onClick={() => setIsDialogOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="bg-[#181818] text-white"
                  onClick={handleCreateUser}
                >
                  Save & Close
                </Button>
              </div>
            </DialogContent>
          </section>
        )}
      </Dialog>
    </div>
  );
};

export default SubUserList;
